export default function (value) {
  var duasLetras = parseInt(value / 26);
  if (duasLetras > 0) {
    var letra =
      String.fromCharCode(97 + duasLetras - 1) +
      String.fromCharCode(97 + (value % 26));
  } else {
    var letra = String.fromCharCode(97 + value);
  }

  return letra;
}
